import { isConceptResponse, isConceptsResponse, } from '@urbanik/api-contracts';
export class ConceptsApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'ConceptsApiError';
    }
}
const endpoint = (base, path = '') => `${base.replace(/\/$/, '')}/identity/governance/concepts${path}`;
async function call(base, path, init) {
    let r;
    try {
        r = await fetch(endpoint(base, path), {
            credentials: 'include',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...init?.headers },
            ...init,
        });
    }
    catch {
        throw new ConceptsApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const body = await r.json();
    if (!r.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos completar la operación.';
        throw new ConceptsApiError(r.status === 401
            ? 'unauthorized'
            : r.status === 403
                ? 'forbidden'
                : r.status === 404
                    ? 'not-found'
                    : r.status === 409
                        ? 'conflict'
                        : r.status === 400
                            ? 'validation'
                            : 'unavailable', message);
    }
    return body;
}
export async function getConcepts(base, signal) {
    const b = await call(base, '', { signal: signal ?? null });
    if (!isConceptsResponse(b))
        throw new ConceptsApiError('invalid', 'El catálogo recibido no es válido.');
    return b;
}
export async function createConcept(base, input) {
    const b = await call(base, '', { method: 'POST', body: JSON.stringify(input) });
    if (!isConceptResponse(b))
        throw new ConceptsApiError('invalid', 'El concepto creado no es válido.');
    return b;
}
export async function updateConcept(base, id, input) {
    const b = await call(base, `/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
    });
    if (!isConceptResponse(b))
        throw new ConceptsApiError('invalid', 'El concepto actualizado no es válido.');
    return b;
}
export async function setConceptActive(base, id, active) {
    const b = await call(base, `/${encodeURIComponent(id)}/${active ? 'activate' : 'deactivate'}`, {
        method: 'POST',
        body: JSON.stringify({}),
    });
    if (!isConceptResponse(b))
        throw new ConceptsApiError('invalid', 'El estado recibido no es válido.');
    return b;
}
